export default __webpack_public_path__ + "static/media/difines.bca305ab.png";